import { Container, Row, Col } from 'reactstrap';
import React from 'react';
import { Button, CardHeader } from 'reactstrap';
import { Link } from 'react-router-dom';
import SimpleHeader from 'components/Headers/SimpleHeader';

import next from 'assets/img/home/arrow right.svg';
import prev from 'assets/img/home/arrow left.svg';

import { ames247Axios } from 'configs/api';
import { useSelector } from 'react-redux';
// import Card from 'reactstrap/lib/Card';
import CardBody from 'reactstrap/lib/CardBody';
import Card from 'reactstrap/lib/Card';
import CardImg from 'reactstrap/lib/CardImg';
import BookActivationComponent from 'modules/ClassModule/components/BookActivationComponent';
import { connect } from 'react-redux';

// const icons = [
//     'fas fa-pen-square fa-4x text-primary',
//     'fas fa-pen-square fa-4x text-yellow',
//     'fas fa-pen-square fa-4x text-green',
//     'fas fa-pen-square fa-4x text-blue',
// ]
const icons = [
  'fas fa-book fa-2x text-primary',
  'fas fa-book fa-2x text-green',
  'fas fa-book fa-2x text-yellow',
  'fas fa-book fa-2x text-blue',
  // 'fas fa-pen-square fa-4x text-primary',
  // 'fas fa-pen-square fa-4x text-yellow',
  // 'fas fa-pen-square fa-4x text-green',
  // 'fas fa-pen-square fa-4x text-blue',
];

const BookDetailComponent = (props) => {
  const [state, setState] = React.useState({
    data: null,
    unitList: [],
    relatedCourseList: [],
    modalVisible: false,
  });
  const activeBook = () => {
    setState((pre) => ({ ...pre, modalVisible: !state.modalVisible }));
  };
  const setModalVisible = () => {
    setState((pre) => ({ ...pre, modalVisible: !state.modalVisible }));
  };

  const CourseId = props.match.params.id;
  const UserId = useSelector((rootState) => rootState.authReducer.loggedInUser?.id);

  React.useEffect(() => {
    ames247Axios
      .post(`/api/GetCourseDetailByCourseId`, { UserId, CourseId })
      .then((res) => {
        const data = res.data;

        setState((...pre) => ({ ...pre, data: data.result[0] }));
      })
      .then(() => {
        ames247Axios.get(`https://cloud.softech.cloud/mobile/Sgk/api/GetUnitByCourseId/${CourseId}`).then((res) => {
          const data = res.data.result;

          setState((pre) => ({ ...pre, unitList: data }));
        });
      })
      .then(() => {
        ames247Axios.get(`https://cloud.softech.cloud/mobile/Sgk/api/GetRelatedCourseByCourseId/${CourseId}`).then((res) => {
          const data = res.data.result;

          setState((pre) => ({ ...pre, relatedCourseList: data }));
        });
      });
  }, [CourseId, UserId]);

  const renderRelatedBook = React.useCallback((data) => {
    return data.map((item, index) => (
      <Col lg={2} md={4} sm={6} xs={12} key={index}>
        <Link key={index} to={`/lms/sach-dien-tu/book-detail/${item.id}`} className='text-center'>
          <img className='rounded' style={{ width: '100%' }} src={item.imageUrl} alt='' />
          <h5 className='mt-2'>{item.title}</h5>
        </Link>
      </Col>
    ));
  }, []);

  return (
    <React.Fragment>
      <SimpleHeader name='Sách điện tử' parentName='Sách số' />
      <Container fluid className='mt--6'>
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <h3 className='mb-0'>{state.data?.title}</h3>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xl={3} lg={4} md={5} sm={6}>
                    <img className='rounded' style={{ width: '100%' }} src={state.data?.imageUrl} alt='' />
                  </Col>
                  <Col xl={9} lg={8} md={7} sm={6}>
                    {state.data && (
                      <React.Fragment>
                        <div className='mb-2'>
                          <strong style={{ fontWeight: 600 }}>Mã sách:</strong> <span>{state.data.code}</span>
                        </div>
                        <div className='mb-2'>
                          <strong style={{ fontWeight: 600 }}>Số trang:</strong> <span>Đang cập nhật</span>
                        </div>
                        <div className='mb-2'>
                          <strong style={{ fontWeight: 600 }}>Nhà xuất bản:</strong> <span>Phương Nam</span>
                        </div>
                        <div className='mb-2'>
                          <strong style={{ fontWeight: 600 }}>Năm phát hành:</strong> <span>{state.data.createdDate.split('T')[0].split('-')[0]}</span>
                        </div>
                        <div className='mb-2'>
                          <strong style={{ fontWeight: 600 }}>Tái bản:</strong> <span>Lần thứ I</span>
                        </div>
                        <Link to={`/lms/classes/${props.match.params.id}/sessions`}>
                          <Button color='primary' className='mt-4'>
                            Xem chi tiết
                          </Button>
                        </Link>
                      </React.Fragment>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <h3 className='mb-0'>Sách liên quan</h3>
              </CardHeader>
              <CardBody>
                <Row>{state.relatedCourseList && renderRelatedBook(state.relatedCourseList)}</Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  loggedInUser: state.authReducer.loggedInUser,
});
export default connect(mapStateToProps)(BookDetailComponent);
